import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Este pack es solo para diabetes tipo 2?',
  a: 'Está diseñado principalmente para personas con diabetes tipo 2 o prediabetes. Si tenés tipo 1, muchas estrategias también aplican, pero siempre consultá con tu médico para ajustes específicos.'
}, {
  q: '¿Necesito saber cocinar?',
  a: 'Para nada. Las recetas son simples, con ingredientes comunes y pasos fáciles. Si podés hervir agua, podés seguir estas guías.'
}, {
  q: '¿Es un libro o un curso?',
  a: 'Es un pack de guías digitales en PDF + acceso a la comunidad y masterclass. No es un curso largo — es material práctico que podés usar desde hoy.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un email con los enlaces de descarga. Podés verlo en tu celular, tablet o computadora.'
}, {
  q: '¿Puedo compartirlo con un familiar?',
  a: 'El acceso es individual, pero entendemos que la diabetes afecta a toda la familia. Muchas personas lo usan junto a su pareja o familiar que cocina.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía. Si no te convence, te devolvemos el dinero completo. Sin preguntas.'
}, {
  q: '¿Esto reemplaza a mi médico?',
  a: 'No. Este pack complementa tu tratamiento médico con herramientas prácticas para el día a día. Siempre seguí las indicaciones de tu profesional de salud.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-[#FEFBF4]" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] text-center mb-12" data-id="element-91">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-92">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-[#1B4332]/10 overflow-hidden" data-id="element-93">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-94">
                <span className="font-bold text-[#1C1917] text-lg" data-id="element-95">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#D97706] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-96" />
              </button>

              <AnimatePresence data-id="element-97">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-98">
                    <div className="px-6 pb-6 text-[#1C1917]/80 leading-relaxed" data-id="element-99">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}